export default __webpack_public_path__ + "static/media/image 14.eb0e42df.svg";